import { CommonModule, DatePipe } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";

import { CategoryChartComponent } from "../category-chart/category-chart.component";
import { RegisterBookChartComponent } from "../charts/register-book-chart/register-book-chart.component";
import { RegisterBookStatusChartComponent } from "../charts/register-book-status-chart/register-book-status-chart.component";
import { ScheduleBookChartComponent } from "../charts/schedule-book-chart/schedule-book-chart.component";
import { VikasKameChartComponent } from "../charts/vikas-kame-chart/vikas-kame-chart.component";
import { NumberConversionDirective } from "../common/directives/number-conversion.directive";
import { AdhikariReassignComponent } from "../complain-box/complain-list/adhikari-reassign/adhikari-reassign.component";
import { ComplainListExpandComponent } from "../complain-box/complain-list/complain-list-expand/complain-list-expand.component";
import { ComplainStatusListComponent } from "../complain-box/complain-list/complain-status-list/complain-status-list.component";
import { KaryakartaReassignComponent } from "../complain-box/complain-list/karyakarta-reassign/karyakarta-reassign.component";
import { ComplaintReportComponent } from "../complain-box/complaint-report/complaint-report.component";
import { ComplainChartComponent } from "../complain-chart/complain-chart.component";
import { DisplayOfficeNameComponent } from "../display-components/display-office-name/display-office-name.component";
import { DumbModule } from "../dumb/dumb.module";
import { HtmlEditorComponent } from "../html-editor/html-editor.component";
import { TopKaryakartaComponent } from "../karyakarta/top-karyakarta/top-karyakarta.component";
import { EmptyOfficeComponent } from "../office/empty-office/empty-office.component";
import { OfficeReportComponent } from "../office/office-report/office-report.component";
import { PinHtmlEditorModule } from "../pin-modules/pin-html-editor-module/pin-html-editor.module";
import { PinTableModule } from "../pin-modules/pin-table-module/pin-table.module";
import { PrimeNgModule } from "../prime-ng/prime-ng.module";
import { RecentDocComponent } from "../recent-doc/recent-doc.component";
import { BirthdayListComponent } from "../todays-birthday/birthday-list/birthday-list.component";
import { AddViewerComponent } from "../viewer-dashboard/add-viewer/add-viewer.component";
import { ViewerListComponent } from "../viewer-dashboard/viewer-list/viewer-list.component";
import { VisitorChartComponent } from "../visitor-chart/visitor-chart.component";
import { CastSubcastComponent } from "./component/cast-subcast/cast-subcast.component";
import { DisplayErrorComponent } from "./component/display-error/display-error.component";
import { DocumentsPopupComponent } from "./component/documents-popup/documents-popup.component";
import { FindExistingVisitorComponent } from "./component/find-existing-visitor/find-existing-visitor.component";
import { LocationBinderComponent } from "./component/location-binder/location-binder.component";
import { NewVisitorFormComponent } from "./component/new-visitor-form/new-visitor-form.component";
import { NoSpecialCharacterComponent } from "./component/no-special-character/no-special-character.component";
import { RemaindersComponent } from "./component/remainders/remainders.component";
import { SearchVisitorComponent } from "./component/search-visitor/search-visitor.component";
import { ValidationAadharComponent } from "./component/validation-aadhar/validation-aadhar.component";
import { ValidationMobileComponent } from "./component/validation-mobile/validation-mobile.component";
import { ActionPermissionDirective } from "./directives/action-permission.directive";
import { FeaturePermissionDirective } from "./directives/feature-permission.directive";
import { MenuPermissionDirective } from "./directives/menu-permission.directive";
import { PipeModule } from "./Pipe/pipe.module";
import { UtilityService } from "./utility.service";
import { ValidationPancardComponent } from "./component/validation-pancard/validation-pancard.component";
import { ValidationVoterComponent } from "./component/validation-voter/validation-voter.component";
import { UserDetailsComponent } from "./component/user-details/user-details.component";
import { NgxSpinnerModule } from "ngx-spinner";
import { VoterEditFormComponent } from './component/voter-edit-form/voter-edit-form.component';

// import { MultiLangModule } from "../multi-lang/multi-lang.module";
@NgModule({
  declarations: [
    CategoryChartComponent,
    ComplainChartComponent,
    ScheduleBookChartComponent,
    RegisterBookChartComponent,
    VikasKameChartComponent,
    VisitorChartComponent,
    ComplainChartComponent,
    OfficeReportComponent,
    TopKaryakartaComponent,
    RecentDocComponent,
    ComplaintReportComponent,
    DisplayOfficeNameComponent,
    MenuPermissionDirective,
    AdhikariReassignComponent,
    ComplainStatusListComponent,
    ComplainListExpandComponent,
    KaryakartaReassignComponent,
    EmptyOfficeComponent,
    ViewerListComponent,
    AddViewerComponent,
    LocationBinderComponent,
    DisplayErrorComponent,
    ValidationMobileComponent,
    ValidationAadharComponent,
    NoSpecialCharacterComponent,
    DocumentsPopupComponent,
    NumberConversionDirective,
    SearchVisitorComponent,
    BirthdayListComponent,
    ActionPermissionDirective,
    HtmlEditorComponent,
    RemaindersComponent,
    FindExistingVisitorComponent,
    CastSubcastComponent,
    NewVisitorFormComponent,
    RegisterBookStatusChartComponent,
    FeaturePermissionDirective,
    ValidationPancardComponent,
    ValidationVoterComponent,
    UserDetailsComponent,
    VoterEditFormComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    PrimeNgModule,
    PipeModule,
    PinTableModule,
    PinHtmlEditorModule,
    ReactiveFormsModule,
    // MultiLangModule,
    DumbModule,
    TranslateModule,
    NgxSpinnerModule,
  ],
  providers: [UtilityService, DatePipe],
  exports: [
    CategoryChartComponent,
    ComplainChartComponent,
    ScheduleBookChartComponent,
    RegisterBookChartComponent,
    VikasKameChartComponent,
    VisitorChartComponent,
    ComplainChartComponent,
    OfficeReportComponent,
    TopKaryakartaComponent,
    RecentDocComponent,
    ComplaintReportComponent,
    DisplayOfficeNameComponent,
    MenuPermissionDirective,
    AdhikariReassignComponent,
    ComplainStatusListComponent,
    ComplainListExpandComponent,
    KaryakartaReassignComponent,
    EmptyOfficeComponent,
    ViewerListComponent,
    AddViewerComponent,
    LocationBinderComponent,
    DisplayErrorComponent,
    ValidationAadharComponent,
    ValidationMobileComponent,
    NoSpecialCharacterComponent,
    DocumentsPopupComponent,
    NumberConversionDirective,
    SearchVisitorComponent,
    BirthdayListComponent,
    ActionPermissionDirective,
    HtmlEditorComponent,
    CastSubcastComponent,
    NewVisitorFormComponent,
    TranslateModule,
    RegisterBookStatusChartComponent,
    FeaturePermissionDirective,
    // MultiLangModule,
    ValidationPancardComponent,
    ValidationVoterComponent,
    UserDetailsComponent,
    ReactiveFormsModule,
    VoterEditFormComponent,
  ],
  entryComponents: [DocumentsPopupComponent, HtmlEditorComponent],
})
export class SharedModule {}
